import { PipeTransform, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { merge } from 'rxjs';
import { equals } from '@awp/core/utils';
import { ContentProvider } from '../content.provider';
import { ContentParser } from '../content.parser';
var ContentPipe = /** @class */ (function () {
    function ContentPipe(contentProvider, contentParser, changeDetectorRef) {
        var _this = this;
        this.contentProvider = contentProvider;
        this.changeDetectorRef = changeDetectorRef;
        this.value = '';
        // any changes in ContentParser.context could result in content being changed
        this.onContentChangedSubscription = merge(contentParser.contextChanged, contentProvider.onLangChanged)
            .subscribe(function () {
            if (_this.lastKey) {
                _this.updateValue(_this.lastKey, _this.lastParams);
            }
        });
    }
    ContentPipe.prototype.updateValue = function (key, interpolateParams) {
        var _this = this;
        // This subscription completes.
        this.contentProvider.get(key, interpolateParams)
            .subscribe(function (value) {
            _this.value = value;
            _this.lastKey = key;
            _this.changeDetectorRef.markForCheck();
        });
    };
    ContentPipe.prototype.transform = function (query) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!query || query.length === 0) {
            return query;
        }
        // if we ask another time for the same key, return the last value
        if (equals(query, this.lastKey) && equals(args, this.lastParams)) {
            return this.value;
        }
        // store the query, in case it changes
        this.lastKey = query;
        // store the params, in case they change
        this.lastParams = args;
        // set the value
        this.updateValue(query, this.interpolateParams(args));
        return this.value;
    };
    ContentPipe.prototype.ngOnDestroy = function () {
        this.onContentChangedSubscription.unsubscribe();
        this.onContentChangedSubscription = undefined;
    };
    ContentPipe.prototype.interpolateParams = function (args) {
        var interpolateParams;
        if (args[0] != null && args.length) {
            if (typeof args[0] === 'string' && args[0].length) {
                // we accept objects written in the template such as {n:1}, {'n':1}, {n:'v'}
                // which is why we might need to change it to real JSON objects such as {"n":1} or {"n":"v"}
                var validArgs = args[0]
                    .replace(/(\')?([a-zA-Z0-9_]+)(\')?(\s)?:/g, '"$2":')
                    .replace(/:(\s)?(\')(.*?)(\')/g, ':"$3"');
                try {
                    interpolateParams = JSON.parse(validArgs);
                }
                catch (e) {
                    throw new SyntaxError("Wrong parameter in TranslatePipe. Expected a valid Object, received: " + args[0]);
                }
            }
            else if (typeof args[0] === 'object' && !Array.isArray(args[0])) {
                interpolateParams = args[0];
            }
        }
        return interpolateParams;
    };
    return ContentPipe;
}());
export { ContentPipe };
